export const locationsList = [
    "Acacías",
    "Aguachica",
    "Apartado",
    "Ibagué",
    "Manizales",
    "Mocoa",
    "Villavicencio",
    "Yopal",
    "Pasto",
    "Arauca",
    "Armenia",
    "Barrancabermeja",
    "Barranquilla",
    "Puerto Boyacá",
    "Rioacha",
    "San Andrés",
    "Montelíbano",
    "Montería",
    "Neiva",
    "Barrancas",
    "Buenaventura",
    "Buga",
    "Cali",
    "Tunja",
    "Tulua",
    "Valledupar",
    "Pereira",
    "Popayán",
    "Bucaramanga",
    "Espinal Tolima",
    "Florencia",
    "Girardot",
    "Cartagena",
    "Cúcuta",
    "Duitama",
    "Santa Marta",
    "Sincelejo",
    "Sogamoso",
    "Palmira"
]

export const locationsCords = {
    "Acacías":{x:252.3, y: 259.4, type: 0},
    "Aguachica":{x:254.6, y: 134.1, type: 0},
    "Apartado":{x:168.4, y: 145.3, type: 0},
    "Ibagué":{x:206.7, y: 249.1, type: 1},
    "Manizales":{x:196.8, y: 227.3, type: 0},
    "Mocoa":{x:164.5, y: 346.4, type: 1},
    "Villavicencio":{x:258.1, y: 253.7, type: 0},
    "Yopal":{x:292.9, y: 219.2, type: 0},
    "Pasto":{x:145, y: 344.1, type: 1},
    "Arauca":{x:340.5, y: 173.3, type: 0},
    "Armenia":{x:193.8, y: 244, type: 0},
    "Barrancabermeja":{x:248.8, y: 168.4, type: 0},
    "Barranquilla":{x:219.2, y: 56.1, type: 1},
    "Puerto Boyacá":{x:233.4, y: 202, type: 0},
    "Rioacha":{x:279.8, y: 39.8, type: 0},
    "San Andrés":{x:57.8, y: 75.3, type: 0},
    "Montelíbano":{x:204.9, y: 139.1, type: 0},
    "Montería":{x:187.3, y: 116.9, type: 0},
    "Neiva":{x:208.4, y: 293.2, type: 2},
    "Barrancas":{x:275.2, y: 56.3, type: 0},
    "Buenaventura":{x:155.3, y: 259.4, type: 1},
    "Buga":{x:180.2, y: 261.7, type: 0},
    "Cali":{x:168.6, y: 276.1, type: 1},
    "Tunja":{x:263.4, y: 212.2, type: 1},
    "Tulua":{x:183.1, y: 253.7, type: 0},
    "Valledupar":{x:265.1, y: 67.6, type: 0},
    "Pereira":{x:190.8, y: 234.9, type: 1},
    "Popayán":{x:165.2, y: 306.4, type: 1},
    "Bucaramanga":{x:267.7, y: 165.9, type: 1},
    "Espinal Tolima":{x:216.3, y: 255.1, type: 0},
    "Florencia":{x:197.3, y: 331.1, type: 0},
    "Girardot":{x:222.4, y: 249.9, type: 0},
    "Cartagena":{x:205.9, y: 72.6, type: 1},
    "Cúcuta":{x:276.6, y: 143.2, type: 1},
    "Duitama":{x:276.5, y: 204, type: 0},
    "Santa Marta":{x:244.2, y: 50.6, type: 1},
    "Sincelejo":{x:202.3, y: 103.4, type: 0},
    "Sogamoso":{x:272.7, y: 220.1, type: 0},
    "Palmira":{x:177.9, y: 272.2, type: 0}
}